var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05452 7.05452H8.29089C8.08836 7.05452 7.89413 6.97407 7.75092 6.83086C7.60772 6.68765 7.52726 6.49342 7.52726 6.29089C7.52726 6.08836 7.60772 5.89413 7.75092 5.75092C7.89413 5.60771 8.08836 5.52726 8.29089 5.52726H16.6908V4.76363C16.6908 4.5611 16.6104 4.36687 16.4672 4.22366C16.324 4.08045 16.1297 4 15.9272 4H7.52726C7.12221 4 6.73374 4.16091 6.44732 4.44732C6.16091 4.73374 6 5.12221 6 5.52726V17.7453C6 18.5853 6.68727 19.2726 7.52726 19.2726H16.6908C17.0959 19.2726 17.4843 19.1117 17.7708 18.8253C18.0572 18.5389 18.2181 18.1504 18.2181 17.7453V7.81815C18.2181 7.61563 18.1376 7.42139 17.9944 7.27818C17.8512 7.13498 17.657 7.05452 17.4545 7.05452H12.109V13.1636L10.5818 11.6363L9.05452 13.1636V7.05452Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/Docs.f3120d60.svg";
export { ForwardRef as ReactComponent };